import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { Box, ModalClose } from '@mui/joy';
import { Popover, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useForm } from "react-hook-form"

const dataProviderName = 'campaigns/campaignautoassignment';
const wizardAction = 'operatorAutoAssignment'

const OperatorAutoAssignation = ({ campaignId, setSelected, onActionDone }) => {
    const { t } = useTranslation();
    const { doAction, item, success, saving } = useDataProvider(dataProviderName);
    const { loadAll: loadAllCampaignLead } = useDataProvider('campaigns/campaignlead');
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [result, setResult] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [resultOpen, setResultOpen] = useState(false);
    const { setValue, getValues } = useForm()

    const handleOperatorAssignation = (e) => {



        setAnchorEl(e.currentTarget);


        doAction({
            action: wizardAction,
            model: dataProviderName,
            data: { campaignId: campaignId }
        }).then((res) => {
            setDataLoaded(true);
            
            if (onActionDone) onActionDone(res);
        })
    };

    const handleClose = () => {
        setAnchorEl(null);
        setDataLoaded(false);
        setResultOpen(false);
    };

    useEffect(() => {
        //console.info('0 SBIANCO RISULTATI')
        handleClose();
    }, []);

    useEffect(() => {
        //console.info('2 ARRIVATO RISULTATO DEVO SPUTARE POP UP', item, item?.data?.result)
        //setSelected([]);
        setResult(item?.data?.result);
    }, [dataLoaded]);

    useEffect(() => {
        if (!dataLoaded) {
            //console.info('3 RESULT è VUOTO QUINDI CHIUDO', result)
            setResultOpen(false);
        } else {
            //console.info('3 RESULT è PIENO QUINDI APRO', result)
            setResultOpen(true);
        }
    }, [result]);

    return (
        <>
            <Button
                onClick={handleOperatorAssignation}
                label={t("Auto Assegna")}
                icon="faPeopleArrows"
                family="fas"
                variant="solid"
                size="small"
                className="button-select"
                loading={saving}
            />
            <OperatorAssignationResult
                open={resultOpen}
                result={result}
                anchorEl={anchorEl}
                onClose={handleClose}
            />
        </>
    );
};

const OperatorAssignationResult = ({ open, result, anchorEl, onClose }) => {
    const { t } = useTranslation();

    //console.info('RIDISEGNO OperatorAssignationResult', anchorEl, result, open)
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            sx={{
                '& .MuiPopover-paper': {
                    top: '50% !important',
                    left: '50% !important',
                    transform: 'translate(-50%, -50%) !important',
                    width: 500,
                    maxWidth: 500,
                    maxHeight: '80vh',
                }
            }}
            disableRestoreFocus
            disableAutoFocus
            disableEnforceFocus
            className="mtska-child-row-info-detail"
        >
            <Box sx={{ p: 2, minWidth: 200 }}>
                <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider', flexShrink: 0, mb: 2, pt: 0 }}>
                    <Typography variant="h6">Risultati Assegnazione</Typography>
                </Box>
                <List sx={{ p: 0, paddingTop: 2 }}>
                    {result?.map((operator, index) => (
                        <ListItem key={index} sx={{ p: 0, paddingLeft: 2 }} className='mtska-autoassignment-result-item'>
                            <ListItemText
                                primary={operator.name}
                                secondary={
                                    <>
                                        <div>Assegnazioni: {operator.numberOfAssignations}</div>
                                        <div>Città: {operator.workedCities.join(', ')}</div>
                                    </>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Popover>
    );
};


export default OperatorAutoAssignation;
